<script>
import axios from "axios";
import {toast} from "vue3-toastify";
import modalKkMixin from "../conversation-club/modal-kk-mixin.js";
import vSelect from "vue-select";
import _ from "lodash";

export default {
  name: "lesson-instance",
  components: {vSelect},
  mixins: [modalKkMixin],
  props: ['lesson', 'instance', 'admin', 'currentuser'],
  data() {
    return {
      lesson_instance: {
        when: '',
        minutes: 45,
        students: [],
        lecturer_id: null,
        lesson_topic: '',
        feedback: '',
        lesson_state: 'lesson_took_place',
        additional_information: '',
        next_lesson: ''
      },
      students: [],
      selected_student: {},
      lectors: [],
      isLoading: false
    };
  },
  computed: {
    // Maximální počet studentů podle typu lekce z parent lesson
    maxStudents() {
      if (!this.lesson || !this.lesson.lesson_type) return Infinity;
      
      if (this.lesson.lesson_type === 'one_to_one') return 1;
      if (this.lesson.lesson_type === 'minicall') return 1;
      if (this.lesson.lesson_type === 'two_students') return 2;
      if (this.lesson.lesson_type === 'group') return Infinity;
      return Infinity;
    },
    
    // Lze přidat další studenty?
    canAddMoreStudents() {
      if (!this.lesson) return false;
      
      // Spočítat aktuální počet studentů
      const currentCount = Object.keys(this.selected_student).filter(key => {
        const student = this.selected_student[key];
        return student && Object.keys(student).length > 0;
      }).length;
      
      // Kontrola limitu
      return currentCount < this.maxStudents;
    },
    
    // Popisek zobrazující stav přidaných studentů
    studentCountLabel() {
      if (!this.lesson || !this.lesson.lesson_type) return '';
      
      const currentCount = Object.keys(this.selected_student).filter(key => {
        const student = this.selected_student[key];
        return student && Object.keys(student).length > 0;
      }).length;
      
      if (this.lesson.lesson_type === 'group') {
        return `Přidáno: ${currentCount} ${currentCount === 1 ? 'student' : (currentCount < 5 ? 'studenti' : 'studentů')}`;
      }
      
      return `Přidáno: ${currentCount} / ${this.maxStudents}`;
    },

    // Check if this is a substitute lesson
    isSubstitute() {
      if (!this.lesson || !this.currentuser) return false;
      return this.lesson.lector_id !== this.currentuser.id;
    },

    // Get the original lector name
    originalLectorName() {
      if (!this.lesson || !this.lesson.lector) return '';
      return `${this.lesson.lector.first_name} ${this.lesson.lector.last_name}`;
    }
  },
  watch: {
    showM(newVal) {
      if (newVal) {
        if (this.instance) {
          this.loadInstanceData();
        } else if (this.lesson) {
          this.initializeLessonInstance();
        }
      }
    }
  },
  mounted() {
    this.loadLectors();
  },
  methods: {
    loadInstanceData() {
      // Převeď datum do formátu YYYY-MM-DDTHH:mm pro datetime-local input
      let formattedWhen = '';
      if (this.instance.when) {
        const date = new Date(this.instance.when);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        formattedWhen = `${year}-${month}-${day}T${hours}:${minutes}`;
      }

      // Naplň formulář z existující instance
      this.lesson_instance = {
        id: this.instance.id,
        when: formattedWhen,
        minutes: this.instance.minutes,
        lecturer_id: this.instance.lecturer_id,
        lesson_topic: this.instance.lesson_topic,
        feedback: this.instance.feedback,
        lesson_state: this.instance.lesson_state,
        additional_information: this.instance.additional_information,
        next_lesson: this.instance.next_lesson,
        ll_lesson_id: this.instance.ll_lesson_id,
        students: []
      };

      // Inicializuj pole students a selected_student
      if (this.instance.students && this.instance.students.length > 0) {
        this.lesson_instance.students = this.instance.students.map(student => ({
          id: student.id,
          email: student.email,
          name: student.name,
          surname: student.surname,
          attended: student.attended !== undefined ? student.attended : true
        }));

        const selected = {};
        this.instance.students.forEach(student => {
          selected[student.id] = {
            ...student,
            attended: student.attended !== undefined ? student.attended : true
          };
        });
        this.selected_student = selected;
      } else {
        this.lesson_instance.students = [];
        this.selected_student = {};
      }
    },
    initializeLessonInstance() {
      // Zkopíruj relevantní data z lesson do lesson_instance
      this.lesson_instance.minutes = this.lesson.minutes || 45;
      
      // Pro lektora (non-admin) použij ID aktuálního uživatele
      // Pro admina použij lektora z lekce nebo nech prázdné
      if (!this.admin && this.currentuser && this.currentuser.id) {
        this.lesson_instance.lecturer_id = this.currentuser.id;
      } else {
        this.lesson_instance.lecturer_id = this.lesson.lector_id || this.lesson.lector?.id || null;
      }
      
      this.lesson_instance.ll_lesson_id = this.lesson.id || null;

      // Zkopíruj studenty z lekce
      if (this.lesson.students && this.lesson.students.length > 0) {
        this.lesson_instance.students = [...this.lesson.students];
        this.students = [...this.lesson.students];

        const selected = {};
        this.lesson.students.forEach(student => {
          selected[student.id] = {
            ...student,
            attended: true  // Default všichni přítomní
          };
        });
        this.selected_student = selected;
      } else {
        this.lesson_instance.students = [];
        this.selected_student = {};
      }

      // Vynuluj pole, která se nemají přenášet
      this.lesson_instance.when = '';
      this.lesson_instance.lesson_topic = '';
      this.lesson_instance.feedback = '';
      this.lesson_instance.lesson_state = 'lesson_took_place';
      this.lesson_instance.additional_information = '';
      this.lesson_instance.next_lesson = '';
    },
    removeStudent(index) {
      const studentToRemove = this.selected_student[index];
      console.log('Removing student:', index, studentToRemove);
      if (studentToRemove) {
        delete this.selected_student[index];
      }
      this.lesson_instance.students.splice(index, 1);

    },
    addNewStudentSlot() {
      // Kontrola limitu
      if (!this.canAddMoreStudents) {
        const lessonType = this.lesson?.lesson_type;
        const typeName = lessonType === 'one_to_one' ? 'one-to-one' : 
                         lessonType === 'two_students' ? 'párovou lekci' : 'skupinovou lekci';
        toast.warning(`Pro ${typeName} můžete přidat max. ${this.maxStudents} ${this.maxStudents === 1 ? 'studenta' : 'studenty'}.`);
        return;
      }
      
      if (!this.selected_student) {
        this.selected_student = {};
      }
      const tempId = `new_record_${Date.now()}`;
      this.selected_student[tempId] = { is_new_record: true, email: '', name: '', surname: '', attended: true }
      this.lesson_instance.students.push({ id: tempId, is_new_record: true, email: '', name: '', surname: '', attended: true });
    },
    addStudentSlot() {
      // Kontrola limitu
      if (!this.canAddMoreStudents) {
        const lessonType = this.lesson?.lesson_type;
        const typeName = lessonType === 'one_to_one' ? 'one-to-one' : 
                         lessonType === 'two_students' ? 'párovou lekci' : 'skupinovou lekci';
        toast.warning(`Pro ${typeName} můžete přidat max. ${this.maxStudents} ${this.maxStudents === 1 ? 'studenta' : 'studenty'}.`);
        return;
      }

      if (!this.selected_student) {
        this.selected_student = {};
      }
      const tempId = `new_${Date.now()}`;

      this.selected_student[tempId] = { attended: true };
    },
    toggleAttendance(index) {
      if (this.selected_student[index]) {
        this.selected_student[index].attended = !this.selected_student[index].attended;
      }
    },
    onSearchStudent(search, loading) {
      if(search.length) {
        loading(true);
        this.searchStudent(loading, search, this);
      }
    },
    searchStudent: _.debounce((loading, search, vm) => {
      fetch(`/ll/students/all?q=${encodeURIComponent(search)}`)
        .then(res => {
          res.json().then(json => (vm.students = json.items));
          loading(false);
        });
    }, 350),
    async loadLectors() {
      const response = await axios.get('/ll/lectors_options.json', {
        params: { per: 100 }
      });
      this.lectors = response.data.items;
    },
    sendData() {
      // Detailní validace povinných polí
      const missingFields = [];
      
      if (!this.lesson_instance.when) {
        missingFields.push('When');
      }
      if (!this.lesson_instance.minutes) {
        missingFields.push('How many minutes');
      }
      if (!this.lesson_instance.lecturer_id) {
        missingFields.push('Lecturer');
      }
      if (!this.lesson_instance.lesson_topic) {
        missingFields.push('Lesson topic');
      }
      if (!this.lesson_instance.feedback) {
        missingFields.push('Feedback');
      }
      if (!this.lesson_instance.lesson_state) {
        missingFields.push('Lesson state');
      }
      
      // Pokud nějaká pole chybí, zobraz je
      if (missingFields.length > 0) {
        const fieldList = missingFields.map(f => `• ${f}`).join('\n');
        console.log('Validation failed. Missing fields:', missingFields);
        console.log('Current lesson_instance values:', {
          when: this.lesson_instance.when,
          minutes: this.lesson_instance.minutes,
          lecturer_id: this.lesson_instance.lecturer_id,
          lesson_topic: this.lesson_instance.lesson_topic,
          feedback: this.lesson_instance.feedback,
          lesson_state: this.lesson_instance.lesson_state
        });
        toast.error(`Please fill in the following required fields:\n\n${fieldList}`, {
          autoClose: 8000,
          position: 'top-center'
        });
        return;
      }

      // ============================================================
      // VALIDACE: Kontrola duplicitních studentů
      // ============================================================
      const studentIds = new Set();
      const studentEmails = new Set();
      const duplicates = [];
      
      // Projít všechny sloty studentů
      const studentKeys = Object.keys(this.selected_student);
      studentKeys.forEach((key, index) => {
        const student = this.selected_student[key];
        
        if (!student || Object.keys(student).length === 0) {
          // Prázdný slot - přeskočit
          return;
        }
        
        if (student.is_new_record) {
          // === NOVÝ ZÁZNAM STUDENTA (vytváří se nový student) ===
          const email = student.email?.toLowerCase().trim();
          
          if (!email) {
            duplicates.push(`Slot ${index + 1}: Email nového studenta je povinný`);
            return;
          }
          
          // Kontrola duplicity emailu mezi novými záznamy
          if (studentEmails.has(email)) {
            duplicates.push(`Student s emailem "${student.email}" je v lekci vícekrát`);
          } else {
            studentEmails.add(email);
          }
        } else {
          // === EXISTUJÍCÍ STUDENT (vybraný z dropdownu) ===
          if (!student.id) {
            duplicates.push(`Slot ${index + 1}: Vyberte studenta nebo ho odstraňte`);
            return;
          }
          
          const studentId = student.id;
          const studentEmail = student.email?.toLowerCase().trim();
          
          // Kontrola duplicity ID
          if (studentIds.has(studentId)) {
            duplicates.push(
              `${student.name} ${student.surname} (${student.email}) je v lekci vícekrát`
            );
          } else {
            studentIds.add(studentId);
            if (studentEmail) studentEmails.add(studentEmail);
          }
        }
      });
      
      // Kontrola duplicit mezi novými záznamy a existujícími studenty
      studentKeys.forEach(key => {
        const student = this.selected_student[key];
        if (student && student.is_new_record) {
          const newEmail = student.email?.toLowerCase().trim();
          
          // Najít existujícího studenta se stejným emailem
          const existingStudent = Object.values(this.selected_student).find(s => 
            s && !s.is_new_record && s.email?.toLowerCase().trim() === newEmail
          );
          
          if (existingStudent) {
            duplicates.push(
              `Student s emailem "${student.email}" je již vybrán jako existující student (${existingStudent.name} ${existingStudent.surname})`
            );
          }
        }
      });
      
      // Pokud byly nalezeny chyby, zobrazit a zastavit
      if (duplicates.length > 0) {
        const errorMessage = duplicates.length === 1 
          ? duplicates[0]
          : `Nelze uložit - nalezeny následující problémy:\n• ${duplicates.join('\n• ')}`;
        
        toast.error(errorMessage, {
          autoClose: 8000,
          position: 'top-center'
        });
        return;
      }

      // ============================================================
      // VALIDACE: Kontrola počtu studentů podle typu lekce
      // ============================================================

      if (this.lesson && this.lesson.lesson_type) {
        // Spočítat validní studenty (ne prázdné sloty)
        const validStudentCount = Object.keys(this.selected_student).filter(key => {
          const student = this.selected_student[key];
          return student && Object.keys(student).length > 0;
        }).length;

        // Validace podle typu lekce
        if (this.lesson.lesson_type === 'one_to_one') {
          if (validStudentCount !== 1) {
            toast.error("Pro výuku one-to-one musí být na lekci právě 1 student.");
            return;
          }
        }

        if (this.lesson.lesson_type === 'two_students') {
          if (validStudentCount !== 2) {
            toast.error("Pro párovou lekci musí být na lekci právě 2 studenti.");
            return;
          }
        }

        if (this.lesson.lesson_type === 'group') {
          if (validStudentCount < 1) {
            toast.error("Pro skupinovou lekci musí být na lekci alespoň 1 student.");
            return;
          }
        }
      }

      // ============================================================
      // KONEC VALIDACE POČTU STUDENTŮ
      // ============================================================

      // Připrav finální seznam studentů , preved hash na pole, odstran klice, u novych studentu ponech vsechny udaje
      const finalStudents = []
      for(const key in this.selected_student) {
        const student = this.selected_student[key];
        if (student.is_new_record) {
          finalStudents.push({
            email: student.email,
            name: student.name,
            surname: student.surname,
            is_new_record: true,
            attended: student.attended !== undefined ? student.attended : true
          });
        } else {
          finalStudents.push({
            id: student.id,
            attended: student.attended !== undefined ? student.attended : true
          });
        }
      }


      const lessonInstanceData = {
        ...this.lesson_instance,
        students: finalStudents
      };

      const url = this.lesson_instance.id ? `/ll/lesson_instances/${this.lesson_instance.id}.json` : '/ll/lesson_instances.json';
      const method = this.lesson_instance.id ? 'patch' : 'post';

      axios.request({
        method,
        url,
        data: { lesson_instance: lessonInstanceData }
      }).then(response => {
        this.$emit('save-lesson-instance', this.lesson_instance);
        this.hideModal();
        toast.success("Odučená lekce byla zaznamenána.");
      }).catch(error => {
        console.error('Došlo k chybě při ukládání odučené lekce:', error);
        toast.error("Došlo k chybě při ukládání odučené lekce.");
      });
    }
  }
}
</script>

<template>
  <vue-final-modal v-model="showM" classes="modal-container" content-class="modal-content-f w900">
    <div class="modal-header">
      <h5 class="modal-title">Zaznamenání odučené lekce</h5>
      <button type="button" class="close" @click="hideModal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal__content">
      <div class="row">
        <!-- Levý sloupec - Základní 3 pole -->
        <div class="col-md-4">
          <div class="form-group">
            <label>When <span class="text-danger">*</span></label>
            <input type="datetime-local" class="form-control" v-model="lesson_instance.when" required />
          </div>

          <div class="form-group">
            <label>How many minutes <span class="text-danger">*</span></label>
            <select class="form-control" v-model="lesson_instance.minutes" required>
              <option :value="30">30 min</option>
              <option :value="45">45 min</option>
              <option :value="60">60 min</option>
              <option :value="80">80 min</option>
            </select>
          </div>

          <div class="form-group">
            <label>Lecturer <span class="text-danger">*</span></label>
            <select class="form-control" v-model="lesson_instance.lecturer_id" required :disabled="!admin">
              <option value="">Vyberte lektora</option>
              <option v-for="lector in lectors" :key="lector.id" :value="lector.id">
                {{ lector.first_name }} {{ lector.last_name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Pravý sloupec - Studenti -->
        <div class="col-md-8">
          <!-- Substitute indicator -->
          <div v-if="isSubstitute" class="alert alert-info mb-3">
            <strong><i class="fas fa-exchange-alt mr-2"></i>Záskok:</strong> 
            Zaznamenáváte lekci za {{ originalLectorName }}
          </div>

          <div class="students-section">
            <h6 class="mb-3">
              <i class="fas fa-users mr-2"></i>Students
            </h6>

            <div v-for="(student, index) in selected_student" :key="index" class="student-row mb-2">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <div v-if="!student.is_new_record">
                    <v-select 
                      v-model="selected_student[index]" 
                      @search="onSearchStudent" 
                      :filterable="false" 
                      :options="students" 
                      label="email"
                      placeholder="Vyberte studenta..."
                    >
                      <template #option="option">
                        <div class="d-flex">
                          <div class="">{{ option.email }}</div>
                          <div class="ml-2"><b>{{ option.name }} {{ option.surname }}</b></div>
                        </div>
                      </template>
                      <template #selected-option="option">
                        <div class="d-flex">
                          <div class="">{{ option.email }}</div>
                          <div class="ml-2"><b>{{ option.name }} {{ option.surname }}</b></div>
                        </div>
                      </template>
                    </v-select>
                  </div>
                  <div v-else>
                    <div class="row g-1">
                      <div class="col-4">
                        <input type="email" v-model="student.email" placeholder="Email" class="form-control form-control-sm">
                      </div>
                      <div class="col-4">
                        <input type="text" v-model="student.name" placeholder="Jméno" class="form-control form-control-sm">
                      </div>
                      <div class="col-4">
                        <input type="text" v-model="student.surname" placeholder="Příjmení" class="form-control form-control-sm">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ml-2">
                  <button 
                    @click="toggleAttendance(index)" 
                    :class="['btn', 'btn-sm', student.attended !== false ? 'btn-success' : 'btn-secondary']"
                    style="font-size: 0.8rem; min-width: 95px;"
                  >
                    <i :class="['fas', student.attended !== false ? 'fa-user-check' : 'fa-user-times']"></i>
                    {{ student.attended !== false ? 'Yes' : 'No' }}
                  </button>
                </div>
                <div class="ml-2">
                  <button 
                    @click="removeStudent(index)" 
                    class="attendance-delete-btn"
                    title="Odstranit studenta z lekce"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="mt-3">
              <button 
                class="btn btn-sm btn-outline-primary mr-2" 
                @click="addStudentSlot"
                :disabled="!canAddMoreStudents"
              >
                <i class="fas fa-plus"></i> Existující student
              </button>
              <button 
                class="btn btn-sm btn-outline-success" 
                @click="addNewStudentSlot"
                :disabled="!canAddMoreStudents"
              >
                <i class="fas fa-user-plus"></i> Nový student
              </button>
              
              <!-- Zobrazení počtu přidaných studentů -->
              <div class="mt-2" v-if="Object.keys(selected_student).length > 0">
                <small class="form-text text-muted">
                  <i class="fas fa-users"></i> {{ studentCountLabel }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Plná šířka - Lesson topic -->
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="form-group">
            <label>Lesson topic <span class="text-danger">*</span></label>
            <textarea class="form-control" v-model="lesson_instance.lesson_topic" rows="3" required></textarea>
          </div>
        </div>
      </div>

      <!-- Plná šířka - Feedback -->
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Feedback (on student/-s) <span class="text-danger">*</span></label>
            <textarea class="form-control" v-model="lesson_instance.feedback" rows="3" required></textarea>
          </div>
        </div>
      </div>

      <!-- Dva sloupce - Lesson state a Next lesson -->
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Lesson state <span class="text-danger">*</span></label>
            <select class="form-control" v-model="lesson_instance.lesson_state" required>
              <option value="lesson_took_place">Lesson took place</option>
              <option value="late_cancellation">Late cancellation (by student - paid lesson)</option>
              <option value="free_lesson">Free lesson (by lecturer)</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Next lesson</label>
            <input type="date" class="form-control" v-model="lesson_instance.next_lesson" />
          </div>
        </div>
      </div>

      <!-- Plná šířka - Additional information -->
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Additional information</label>
            <textarea class="form-control" v-model="lesson_instance.additional_information" rows="2"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button @click="hideModal" type="button" class="btn btn-outline-dark">Zrušit</button>
      <button @click="sendData" class="btn btn-success">
        Zaznamenat lekci
      </button>

    </div>
  </vue-final-modal>
</template>

<style scoped>
.text-danger {
  color: #dc3545;
}

.attendance-delete-btn {
  background: none;
  border: none;
  color: #dc3545;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  transition: color 0.2s ease;
}

.attendance-delete-btn:hover {
  color: #c82333;
}

.attendance-delete-btn:focus {
  outline: none;
}
</style>